var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"preloader",attrs:{"hidden":!_vm.showPreloader}},[_c('img',{staticClass:"lipi-shop-logo",attrs:{"src":require("./assets/lipi-logo.png")}})]),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }